module.exports = __webpack_public_path__ + "img/lg_ring_y_l_null_null@2x.bb65d293.png";